import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/spinner";
import { AdUnitValidations } from "../adsApiValidations";
import { adFormats } from "../../../services/staticData";
import { newAdUnit } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { adsTypes } from "../../../services/staticData";
import { updateAdUnit } from "../../../services/axios/apiManager";

const AddEditUnitModal = ({
  selectedUnit,
  setSelectedUnit,
  showAddEditModal,
  handleHideModal,
  getAdUnits,
  apiId,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleCreateOrEdit = async (data) => {
    if (selectedUnit?.id) {
      const updateResponse = await updateAdUnit({
        apiId,
        ...data,
      });
      if (updateResponse?.data?.success) {
        await getAdUnits();
        toast.success("Ad Unit has been updated!", { duration: 2000 });
        handleHideModal();
      } else {
        handleErrors(updateResponse, navigate, "Ad Unit:");
      }
    } else {
      const addResponse = await newAdUnit({ apiId, ...data });
      if (addResponse?.data?.success) {
        await getAdUnits();
        toast.success("Ad Unit has been Added!", { duration: 2000 });
        handleHideModal();
      } else {
        handleErrors(addResponse, navigate, "Ad Unit:");
      }
    }
  };

  return (
    <Modal
      show={showAddEditModal}
      onHide={handleHideModal}
      centered
      backdrop="static"
      className="text-light"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-light">
          {selectedUnit?.id ? "Edit Ad API" : "Add New Ad API"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            id: selectedUnit?.id || "",
            name: selectedUnit?.name || "",
            code_url: selectedUnit?.code_url || "",
            IMA_url: selectedUnit?.IMA_url || "",
            ad_format: selectedUnit?.ad_format || "",
            type: selectedUnit?.type || "",
            status: selectedUnit?.status || 1,
          }}
          validationSchema={AdUnitValidations}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              if (loading) {
                return;
              }
              console.log("Values :", values);

              await handleCreateOrEdit(values);
            } catch (error) {
              console.log("Error upon Change Password", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div className="row">
              {/* country_name */}
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label>Ad Id*</Form.Label>
                  <Form.Control
                    type="text"
                    id="id"
                    value={values.id}
                    onChange={handleChange("id")}
                    placeholder="Enter Ad Id"
                    className="bg-dark text-light border-light"
                  />
                  {errors?.id && touched?.id ? (
                    <span className="text-danger">{errors?.id}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    id="name"
                    value={values.name}
                    onChange={handleChange("name")}
                    placeholder="Enter Name"
                    className="bg-dark text-light border-light"
                  />
                  {errors?.name && touched?.name ? (
                    <span className="text-danger">{errors?.name}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label>Ad Format*</Form.Label>
                  <Form.Control
                    as="select"
                    id="ad_format"
                    value={selectedUnit.ad_format || 0}
                    onChange={(e) => {
                      setFieldValue("ad_format", e.target.value);
                      setSelectedUnit((prev) => ({
                        ...prev,
                        ad_format: e.target.value,
                      }));
                    }}
                    className="bg-dark text-light border-light"
                  >
                    <option value="">Select Ad Format</option>
                    {adFormats?.map((format) => (
                      <option value={format.label}>{format.value}</option>
                    ))}
                  </Form.Control>
                  {errors?.ad_format && touched?.ad_format ? (
                    <span className="text-danger">{errors?.ad_format}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label>Ad Type*</Form.Label>
                  <Form.Control
                    as="select"
                    id="type"
                    value={selectedUnit.type || 1}
                    onChange={(e) => {
                      setFieldValue("type", e.target.value);
                      setSelectedUnit((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }));
                    }}
                    className="bg-dark text-light border-light"
                  >
                    <option value="">Select Ad Type</option>
                    {adsTypes?.map((format) => (
                      <option value={format.label}>{format.value}</option>
                    ))}
                  </Form.Control>
                  {errors?.type && touched?.type ? (
                    <span className="text-danger">{errors?.type}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-12 mb-3">
                <Form.Group>
                  <Form.Label>Code URL*</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    id="CodeURL"
                    value={values.code_url}
                    onChange={handleChange("code_url")}
                    placeholder="Enter Code URL"
                    className="bg-dark text-light border-light"
                    style={{ whiteSpace: "pre-wrap", resize: "vertical" }}
                  />
                  {errors?.code_url && touched?.code_url ? (
                    <span className="text-danger">{errors?.code_url}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-12 mb-3">
                <Form.Group>
                  <Form.Label>IMA URL</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    id="key"
                    value={values.IMA_url}
                    onChange={handleChange("IMA_url")}
                    placeholder="Enter IMA URL"
                    className="bg-dark text-light border-light"
                    style={{ whiteSpace: "pre-wrap", resize: "vertical" }}
                  />
                  {errors?.IMA_url && touched?.IMA_url ? (
                    <span className="text-danger">{errors?.IMA_url}</span>
                  ) : null}
                </Form.Group>
              </div>
              <div class="container-fluid">
                <div class="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedUnit?.id ? "Update" : "Ad New"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddEditUnitModal;
